import { MENHIR_ENDPOINTS } from '@/common/integrations/menhir/menhir.endpoints';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  getCompensationSpendingBreakdown,
  getCompensationSummary,
} from './compensation.service';
import {
  TCompensationSpendingBreakdown,
  TCompensationSummary,
  TMenhirGetCompensationSpendingBreakdownParams,
} from './compensation.types';

export function useGetCompensationSummary(
  options?: UseQueryOptions<TCompensationSummary, any>
) {
  const { data: summary, ...rest } = useQuery({
    queryKey: [MENHIR_ENDPOINTS.EMPLOYEE.COMPENSATION.ROOT],
    queryFn: getCompensationSummary,
    ...options,
  });

  return { summary, ...rest };
}

export function useGetCompensationSpendingBreakdown(
  params: TMenhirGetCompensationSpendingBreakdownParams,
  options?: UseQueryOptions<TCompensationSpendingBreakdown, any>
) {
  const { data: spendingBreakdown, ...rest } = useQuery({
    queryKey: [
      MENHIR_ENDPOINTS.EMPLOYEE.COMPENSATION.SPENDING_BREAKDOWN,
      params.category_slug,
    ],
    queryFn: () => getCompensationSpendingBreakdown(params),
    ...options,
  });

  return { spendingBreakdown, ...rest };
}
